import { GetterTree } from 'vuex';
import { StateInterface } from '@/interfaces/projects';
import { SampleDetails } from '@/interfaces/samples';


const getters: GetterTree<SampleDetails, StateInterface> = {
    // someGetter( /* state */ ) {
    //     // return true;
    // },
    // projectId(state) {
    //     return state.projectId;
    // },
    // getEntriesByTerm ( state ) => ( term = '' ) => {

    //     if ( term.length === 0 ) return state.projects
    
    //     return state.entries.filter( entry => entry.text.toLowerCase().includes( term.toLocaleLowerCase() ) )
    // }
    getSampleId( state ) {
        return state.sampleId;
    },
    getSampleName( state ) {
        return state.nombre;
    },
    getIdConfFilesGrupo( state ){
        return state.id_conf_files_grupo;
    },
    getSampleTotal( state ) {
        return state.sampleTotal;
    },
    getSampleReview( state ) {
        return state.sampleReview;
    },
    getDeleteUnreviewed( state ) {
        return state.deleteUnreviewed;
    },
    getShowAddDocTypesModal( state ) {
        return state.showAddDocTypesModal;
    },
    getEditSample( state ) {
        return state.editSample;
    }

}



export default getters;